import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";

import Landing from "./Pages/Landing/Landing";
import LabelView from "./Pages/LabelView/LabelView";
import Footer from "./Pages/MasterLayout/Footer";
import Header from "./Pages/MasterLayout/Header";
import MasterLabelReportSimplified from "./Pages/TableView/Components/MasterLabelReportNew";
import { RestrictedFieldsProvider } from "./context/RestrictedFieldsContext";
import { RestrictedToggleProvider } from "./context/RestrictedToggleContext";
import { UploadFiles } from "./Pages/TableView/Components/UploadFiles";
import TurnaroundTimeReport from "./Pages/TableView/Components/TurnaroundTimeReport";
import CvSearch from "./Pages/TableView/Components/CvSearch";
import RefDataDetails from "./Pages/TableView/Components/RefDataDetails";


const RoutesList = () => {
  const RootLayout = (
    <div>
      <Footer />
    </div>
  );

  return (
    <Routes>
      <Route path="/" element={<Navigate replace to="/landing" />} />

      <Route
        path="/browse"
        element={
          <>
           <RestrictedFieldsProvider>
             <RestrictedToggleProvider>
            
            <Header />

            <section
              style={{ minHeight: "80vh" }}
              className="container-xxl my-2"
            >
              <main>
                <LabelView />
              </main>
            </section>
            </RestrictedToggleProvider>
            </RestrictedFieldsProvider>
          </>
        }
      />

<Route
        path="/report"
        element={
          <>
            <Header />

            <section
              style={{ minHeight: "80vh" }}
              className="container-xxl my-2"
            >
              <main>
                <MasterLabelReportSimplified />
              </main>
            </section>
          </>
        }
      />
      <Route
        path="/uploadFiles"
        element={
          <>
            <Header />

            <section
              style={{ minHeight: "80vh" }}
              className="container-xxl my-2"
            >
              <main>
                <UploadFiles/>
              </main>
            </section>
          </>
        }
      />
      <Route
        path="/turnaroundTimeReport"
        element={
          <>
            <Header />

            <section
              style={{ minHeight: "80vh" }}
              className="container-xxl my-2"
            >
              <main>
                <TurnaroundTimeReport/>
              </main>
            </section>
          </>
        }
      />

      <Route
        path="/cvSearch"
        element={
          <>
            <Header />

            <section
              style={{ minHeight: "80vh" }}
              className="container-xxl my-2"
            >
              <main>
                <CvSearch />
              </main>
            </section>
          </>
        }
      />

      <Route
        path="/refdataDetails/:datasetId"
        element={
          <>
            <Header />

            <section
              style={{ minHeight: "80vh" }}
              className="container-xxl my-2"
            >
              <main>
                <RefDataDetails />
              </main>
            </section>
          </>
        }
      />

      <Route path="/landing" element={<Landing />} />
    </Routes>
  );
};

export default RoutesList;
